<template>
  <div class="animated fadeIn" id="contformdiario">
    <b-row>
      <b-col cols="12">
        <b-alert
          :show="dismissCountDown"
          dismissible
          variant="danger"
          @dismiss-count-down="countDownChanged"
        >
          <span v-html="msj_validacion"></span> Será redirigido al listado de comprobantes
          en {{ dismissCountDown }} segundos...
          <b-progress
            variant="info"
            :max="dismissSecs"
            :value="dismissCountDown"
            height="4px"
          >
          </b-progress>
        </b-alert>
      </b-col>
    </b-row>
    <b-row v-show="!no_visible">
      <b-col cols="12">
        <b-card v-if="registro_no_encontrado" class="text-center">
          <div slot="header" class="text-center">
            <strong class="text-danger">Registro no encontrado</strong>
          </div>
          <h1>😪</h1>
        </b-card>
        <b-card no-body :no-block="true" v-else>
          <div slot="header">
            <strong>
              <i class="icon-note"> </i>
              {{ titulo }}
            </strong>
          </div>

          <div v-show="cargando">
            <loader-ag />
            <b-row>
              <p class="text-primary mx-auto">Por favor espere...</p>
            </b-row>
          </div>

          <b-card-body v-show="!cargando">
            <form>
              <b-row>
                <b-col cols="4" col md="2">
                  <b-form-group label="Fecha:">
                    <date-picker
                      :lang="lang"
                      v-model="fechaSelect"
                      format="YYYY-MM-DD"
                      type="date"
                      :clearable="false"
                      :disabled-date="notAfterToday"
                      style="width: 95%"
                      value-type="YYYY-MM-DD"
                    >
                    </date-picker>

                    <b-form-invalid-feedback v-if="error_fecha">{{
                      mensaje_fecha
                    }}</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col cols="6" col sm="3" lg="1">
                  <b-form-group label="T/C:">
                    <b-form-input
                      v-model="tasa_cambio"
                      @change="calcular"
                      autocomplete="off"
                      readonly
                      style="background-color: white"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col cols="6" col sm="4" md="2">
                  <b-form-group label="Moneda:">
                    <b-form-select
                      id="moneda"
                      v-model="monedaSelect"
                      :options="monedas"
                      class="mb-3"
                      value-field="id"
                      text-field="nombre"
                      @change="setMoneda"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
                <!-- <b-col cols="6" col sm="2">
                  <label class="col-form-label">Usar Mismo Centro: </label><br>
                  <c-switch @change="limpiarCentrosDetalles" v-model="mismocentro" class="ml-sm-5 mt-1" color="primary"
                            :checked="false" label variant="pill" v-bind="labelTxt"/>
                </b-col> -->
                <b-col cols="8" col md="3" v-show="centros">
                  <b-form-group label="Centro:">
                    <b-form-select
                      id="centro"
                      v-model="centroSelect"
                      :options="centros"
                      class="mb-3"
                      value-field="id"
                      text-field="nombre"
                      @change="setCentros"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row v-show="isCk">
                <b-col cols="5">
                  <label class="col-form-label" for="paguese_a"
                    >{{ textoCkTransferencia }}:
                  </label>
                  <b-form-input
                    id="paguese_a"
                    v-model.trim="model.paguese_a"
                    @change="calcular"
                    autocomplete="off"
                  ></b-form-input>
                </b-col>
                <b-col cols="2">
                  <label class="col-form-label" for="monto_ck"
                    >Monto {{ simbolo }}:
                  </label>
                  <b-form-input
                    id="monto_ck"
                    min="0"
                    type="number"
                    v-model.number="monto_ck_temp"
                    @change="calcular(index)"
                  ></b-form-input>
                </b-col>
                <b-col cols="1">
                  <label class="col-form-label" for="transf">Transferencia?: </label>
                  <b-form-checkbox
                    id="transf"
                    v-model="transferencia"
                    name="check-button"
                    size="lg"
                    switch
                  ></b-form-checkbox>
                </b-col>
                <b-col cols="2" v-show="transferencia">
                  <label class="col-form-label" for="transfid"
                    >ID de Transferencia:
                  </label>
                  <b-form-input
                    id="transfid"
                    v-model.trim="model.transferencia_id"
                  ></b-form-input>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <label class="col-form-label" for="concepto">Concepto: </label>
                  <b-form-textarea
                    id="concepto"
                    autocomplete="off"
                    rows="2"
                    v-model.trim="model.concepto"
                    @change="calcular"
                    :class="{
                      'is-invalid': error_concepto,
                      'is-valid': model.concepto.length >= 10,
                    }"
                  ></b-form-textarea>
                  <b-form-invalid-feedback v-if="error_concepto">{{
                    mensaje_concepto
                  }}</b-form-invalid-feedback>
                </b-col>
              </b-row>

              <div v-show="false">{{ model }}</div>

              <b-row>
                <b-col class="bordecito table-responsive">
                  <table class="table table-bordered table-condensed table-hover">
                    <thead>
                      <!--<th class="noborderlefttop" width="5%" v-show="!mismocentro">Centro:</th> -->
                      <th
                        :class="{
                          noborderlefttop: mismocentro,
                          nobordertop: !mismocentro,
                        }"
                        width="40%"
                      >
                        Cuenta:
                      </th>
                      <th style="border-top: none; width: 10%">Debe:</th>
                      <th style="border-top: none; width: 10%">Haber:</th>
                      <th style="border: none; width: 5%"></th>
                    </thead>
                    <tbody>
                      <tr v-for="(detalle, index) in model.detalles" :key="`${index}`">
                        <!-- <td class="noborderlefttop" v-show="!mismocentro">
                        <b-form-select
                          id="centro"
                          v-model="detalle.centro"
                          :options="centros"
                          value-field="id"
                          text-field="nombre"
                        ></b-form-select>
                      </td> -->
                        <td
                          :class="{
                            noborderlefttop: mismocentro,
                            nobordertop: !mismocentro,
                          }"
                        >
                          <multiselect
                            :clear="true"
                            v-model="detalle.cuentasearch"
                            placeholder="Buscar cuenta..."
                            :options="cuentas"
                            :custom-label="labelSelect"
                            selectLabel="Presione enter para seleccionar"
                            deselectLabel=""
                            selectedLabel="Seleccionado"
                            label=""
                            track-by="id"
                            :searchable="true"
                            :loading="false"
                            :internal-search="false"
                            :options-limit="15"
                            :limit="10"
                            :allow-empty="true"
                            open-direction="bottom"
                            @search-change="getCuentas($event)"
                            @select="cuenta_seleccionada($event, index)"
                          >
                            <template slot="noResult"> No hay resultados</template>
                            <template slot="noOptions">
                              Buscar por número o nombre de cuenta</template
                            >
                          </multiselect>
                        </td>
                        <td>
                          <b-form-input
                            min="0"
                            type="number"
                            v-model.number="detalle.debito_temp"
                            @change="calcular(index)"
                            style="text-align: right"
                          ></b-form-input>
                        </td>
                        <td>
                          <b-form-input
                            min="0"
                            type="number"
                            v-model.number="detalle.credito_temp"
                            @change="calcular(index)"
                            style="text-align: right"
                          ></b-form-input>
                        </td>
                        <td style="border: none; text-align: left; padding-left: 0.4em">
                          <b-button
                            v-show="index > 1"
                            @click="removerow(index)"
                            size="sm"
                            variant="danger"
                            v-b-tooltip.hover
                            title="Quitar Cuenta"
                            ><i class="fa fa-times"></i
                          ></b-button>
                          <b-button
                            style="margin-left: 0.5em"
                            v-show="model.detalles.length == index + 1"
                            @click="addrow"
                            size="sm"
                            variant="success"
                            v-b-tooltip.hover
                            title="Agregar Cuenta"
                            ><i class="fa fa-plus"></i
                          ></b-button>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr v-show="monedaSelect == 2">
                        <!--<td style="border: none" v-show="!mismocentro"></td>-->
                        <td style="border: none"></td>
                        <td class="text-right">
                          <strong
                            >USD{{
                              (model.total_debe / tasa_cambio)
                                | currency("", 2, { thousandsSeparator: "," })
                            }}</strong
                          >
                        </td>
                        <td class="text-right">
                          <strong
                            >USD{{
                              (model.total_haber / tasa_cambio)
                                | currency("", 2, { thousandsSeparator: "," })
                            }}</strong
                          >
                        </td>
                      </tr>
                      <tr>
                        <!--<td style="border: none" v-show="!mismocentro"></td>-->
                        <td style="border: none"></td>
                        <td class="text-right">
                          <strong
                            >C${{
                              model.total_debe
                                | currency("", 2, { thousandsSeparator: "," })
                            }}</strong
                          >
                        </td>
                        <td class="text-right">
                          <strong
                            >C${{
                              model.total_haber
                                | currency("", 2, { thousandsSeparator: "," })
                            }}</strong
                          >
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  <a
                    v-b-tooltip.hover
                    v-show="cerrar_ventana"
                    class="btn btn-sm btn-info text-white pull-right"
                    @click="cerrar_ventana = false"
                    style="position: relative; left: -4em"
                    title="Mostrar Equivalente y Diferencia"
                  >
                    <i class="fa fa-eye"></i>
                  </a>
                </b-col>
              </b-row>

              <b-row v-show="!cerrar_ventana">
                <div
                  id="ventana-flotante"
                  style="z-index: 999; color: white"
                  :class="{
                    'bg-success': diferencia == 0,
                    'bg-danger': diferencia,
                  }"
                >
                  <span
                    class="pull-right"
                    style="position: relative; top: -0.5em; margin-botton: 1em"
                    ><a title="Cerrar" id="enlaceventanita" @click="cerrar_ventana = true"
                      ><i class="fa fa-times"></i></a
                  ></span>
                  <div class="postip-everywhere mt-1">
                    <table style="padding: 0">
                      <td style="min-width: 150px">
                        <h6>
                          Equivalente <small>{{ simbolo_equivalente }}</small
                          >:
                        </h6>
                      </td>
                      <td class="text-right">
                        <h5>
                          <strong>
                            {{
                              equivalente
                                | currency("", 2, {
                                  thousandsSeparator: ",",
                                })
                            }}
                          </strong>
                        </h5>
                      </td>
                      <tr>
                        <td><h6>Diferencia:</h6></td>
                        <td class="text-right">
                          <h5>
                            <strong>{{
                              diferencia | currency("", 2, { thousandsSeparator: "," })
                            }}</strong>
                          </h5>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </b-row>
            </form>
          </b-card-body>

          <b-navbar class="fixed-bottom" type="dark" variant="dark">
            <div class="mx-auto">
              <button
                :disabled="no_guardar"
                class="btn btn-success text-white"
                @click="guardar()"
              >
                <i class="fa fa-dot-circle-o"></i> Guardar
              </button>
              <router-link class="btn btn-danger text-white ml-2" :to="ruta_cancelar">
                <i class="fa fa-ban" /> Cancelar
              </router-link>
            </div>
          </b-navbar>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
const today = new Date();
import LoaderAg from "../../components/LoaderAg";
import { mapGetters } from "vuex";
import { debounce } from "lodash";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import toastr from "toastr";
import { Switch as cSwitch } from "@coreui/vue";
import Vue2Filters from "vue2-filters";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

export default {
  mixins: [Vue2Filters.mixin],
  components: { DatePicker, Multiselect, cSwitch, LoaderAg },
  name: "Diario-form",
  data: () => {
    return {
      transferencia: false,
      dismissSecs: 10,
      dismissCountDown: 0,
      no_visible: false,
      titulo: "Nuevo Comprobante de Diario",
      tipo_comprobante: 1,
      isCk: false,
      monto_ck_temp: undefined,
      ruta_cancelar: "/comprobantes-diario",
      ruta_guardar: "/api/comprobantes/store",
      isHover: false,
      cerrar_ventana: false,
      fechaSelect: undefined,
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
      simbolo: "",
      simbolo_equivalente: "",
      equivalente: 0,
      tasa_cambio: 0,
      mismocentro: true,
      labelTxt: {
        dataOn: "Si",
        dataOff: "No",
      },
      centroSelect: undefined,
      monedaSelect: 1,
      centros: [],
      monedas: [],
      cuentasSearch: "",
      selectedAddress: null,
      cuentas: [],
      model: {
        id: undefined,
        fecha: "",
        tasa_cambio: 0,
        concepto: "",
        total_debe: 0,
        total_haber: 0,
        centro_id: 0,
        detalles: [
          {
            cuenta: "",
            debito: 0,
            debito_temp: 0,
            credito: 0,
            credito_temp: 0,
            debito_dol: 0,
            credito_dol: 0,
            tasa_cambio: 0,
            moneda_id: undefined,
          },
          {
            cuenta: "",
            debito: 0,
            debito_temp: 0,
            credito: 0,
            credito_temp: 0,
            debito_dol: 0,
            credito_dol: 0,
            tasa_cambio: 0,
            moneda_id: undefined,
          },
        ],
      },
      diferencia: 0,
      error_fecha: null,
      error_concepto: null,
      mensaje_fecha: "Requerido",
      mensaje_concepto: "Requerido",
      no_guardar: true,
      registro_no_encontrado: false,
      cargando: true,
      ya_cargo_por_primera_vez: false,
      msj_validacion:
        "<strong>🛑No se puede editar un comprobante anulado o ya fue aprobado 🛑.</strong>",
    };
  },
  mounted() {
    this.getMonedas();
    this.cargar();
    this.setMoneda();
    this.getCentros();
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
      if (this.dismissCountDown === 0) {
        this.$router.push(this.ruta_cancelar);
      }
    },
    async cargar() {
      this.cargando = true;

      if (this.$route.name == "crearck" || this.$route.name == "elaborar_cheque") {
        this.titulo = "Elaborar Cheque / Transferencia";
        this.isCk = true;
        this.ruta_cancelar = "/cheques-transferencias";
        this.registro_no_encontrado = false;
      }
      if (this.$route.name == "actualizar_comprobante")
        this.titulo = "Actualizar Comprobante";

      if (
        this.$route.name == "Crear Comprobante de Diario" ||
        this.$route.name == "crearck"
      )
        this.registro_no_encontrado = false;
      else if (this.$route.params.id != null) {
        try {
          // eslint-disable-next-line no-undef
          let { data, status } = await axios.post("/api/comprobantes/view", {
            id: this.$route.params.id,
          });
          if (status == 200) {
            if (!data || !data.data[0]) {
              this.registro_no_encontrado = true;
              return;
            }
            let datos = data.data[0];
            if (parseInt(datos.estado) === 1 || parseInt(datos.anulado === 1)) {
              this.no_visible = true;
              this.countDownChanged(10);
            } else {
              datos.detalles = datos.vdetalles;
              this.model = datos;
              if (
                this.model &&
                this.model.empresa_id &&
                parseInt(this.model.empresa_id) !== parseInt(this.empresaId)
              ) {
                console.log(this.model.empresa_id);
                console.log("vuex", this.empresaId);
                this.no_visible = true;
                let empresas = ["Aldea Global", "Aldea Coffee", "AldeaZON"];
                let empresa_selecionada = empresas[parseInt(this.empresaId) - 1];
                let empresa_comprobante = empresas[parseInt(this.model.empresa_id) - 1];
                this.dismissSecs = 20;
                this.msj_validacion = `<strong>👀 El comprobante pertenece a otra empresa</strong>. Actualmente usted está en la empresa <strong>${empresa_selecionada}</strong> y el comprobante fue realizado en la empresa <strong>${empresa_comprobante}</strong>, cambie a esa empresa <strong>(${empresa_comprobante})</strong> y vuelva a intentarlo`;
                this.countDownChanged(20);
                return;
              }

              if (this.model.transferencia_id) this.transferencia = true;
              this.centro_id = datos.centro_id;
              // eslint-disable-next-line no-undef
              this.model.fecha = moment(datos.fecha).format("YYYY-MM-DD");
              this.fechaSelect = this.model.fecha;
              this.centroSelect = datos.centro_id ? String(datos.centro_id) : undefined;

              this.model.detalles.forEach((detalle) => {
                detalle.debito_temp = detalle.debito;
                detalle.credito_temp = detalle.credito;
                if (parseInt(detalle.moneda) == 2) {
                  detalle.debito_temp = detalle.debito_dol;
                  detalle.credito_temp = detalle.credito_dol;
                }
                let cuenta = detalle.cuenta;
                // eslint-disable-next-line no-undef
                axios
                  .post("/api/catalogos/busquedacta", {
                    empresa_id: this.empresaId,
                    cuenta,
                    tipo: "Operativa",
                  })
                  .then(({ data }) => {
                    let suggestions = data.data;
                    this.cuentas = suggestions;
                    detalle.cuentasearch = this.cuentas.find(
                      (option) => option.cuenta === detalle.cuenta
                    );
                    this.cuentas = [];
                  });
              });
              this.monedaSelect = datos.moneda_id;
              this.setMoneda();
            }
          } else this.registro_no_encontrado = true;
        } catch (error) {
          toastr["error"](`Error :( ${error}`);
          console.log(error);
        }
      } else this.registro_no_encontrado = true;
      this.cargando = false;
      this.ya_cargo_por_primera_vez = true;
    },
    labelSelect({ cuenta, nombre }) {
      return cuenta + " " + this.text_truncate(nombre, 35);
    },
    text_truncate(str, length, ending) {
      if (ending == null) {
        ending = "...";
      }
      if (typeof str != "undefined") {
        if (str.length > length) {
          return str.substring(0, length - ending.length) + ending;
        } else {
          return str;
        }
      }
    },
    Redondear(numero, decimales) {
      if (!numero) return 0;
      if (decimales == null || decimales == undefined || decimales == "undefined")
        return Math.round(numero);
      let base = Math.pow(10, decimales);
      return Math.round(numero * base) / base;
    },
    async getCentros() {
      let model = {};
      model.empresa_id = this.empresaId;
      // eslint-disable-next-line no-undef
      let { data } = await axios.post("/api/catalogos/centros", { model });
      if (data && data.data) this.centros = data.data;
    },
    async getMonedas() {
      // eslint-disable-next-line no-undef
      let { data } = await axios.get("/api/catalogos/monedas");
      if (data.data) this.monedas = data.data;
    },
    async guardar() {
      if (this.transferencia && !this.model.transferencia_id)
        return toastr["warning"](
          "Favor verificar. Ingrese el codigo o identificador de la transfrencia realizada"
        );
      if (this.transferencia) this.tipo_comprobante = 1;

      if (this.model.centro_id === 0)
        return toastr["warning"]("Favor verificar. Seleccione un centro de negocio");

      if (this.model.concepto.length < 10)
        return toastr["warning"](
          "Favor verificar. Concepto debe ser de almenos 10 caracteres"
        );
      if (this.isCk && this.model.paguese_a.length < 3)
        return toastr["warning"](
          "Favor verificar. Paguese a no puede tener menos de 3 caracteres"
        );
      this.model.empresa_id = this.empresaId;

      if (this.isCk) {
        this.tipo_comprobante = 2;
        let cuenta_ck = 0;
        for (let i = 0; i < this.model.detalles.length; i++) {
          if (parseInt(this.model.detalles[i].credito) > 0) {
            // eslint-disable-next-line no-undef
            let { status, data } = await axios.post(
              "/api/catalogos/comprobar-cuentas-ck",
              {
                cuenta: this.model.detalles[i].cuenta,
                empresa_id: this.empresaId,
              }
            );
            if (status == 200 && data) {
              if (parseInt(data) === 1) {
                this.model.cuenta_ck = this.model.detalles[i].cuenta;
                console.log(this.model.cuenta_ck);
                if (
                  this.isCk &&
                  parseFloat(this.model.detalles[i].credito_temp) !==
                    parseFloat(this.monto_ck_temp)
                )
                  return toastr["error"](
                    "El monto a pagar del cheque debe coincidir con el monto de salida de la cuenta de banco"
                  );
              }
              cuenta_ck += data;
            }
          }
        }
        if (cuenta_ck == 0)
          return toastr["error"](
            "Favor ingresar una cuenta de Banco, la cual debe estar definida en Configuraciones - Cuentas para Cheques"
          );
        if (cuenta_ck > 1)
          return toastr["error"]("Solo Puede usar una cuenta de Banco en el haber");
      }

      // eslint-disable-next-line no-undef
      let { data } = await axios.post(this.ruta_guardar, {
        model: this.model,
        tipo: this.tipo_comprobante,
      });
      if (data && data.status == "fail") {
        toastr["error"](`${data.errors}`);
        return;
      }
      if (data && data.status == "ok" && !this.isCk) {
        toastr["success"]("Comprobante Guardado Correctamente");
        this.$router.push("/comprobantes-diario");
      }
      if (data && data.status == "ok" && this.isCk) {
        toastr["success"]("Cheque Guardado Correctamente");
        this.$router.push("/cheques-transferencias");
      }
      if (data && data.status == "asentado") {
        toastr["error"](
          `🛑 No se puede Guardar. El mes de la fecha seleccionada <strong>ya fué cerrado</strong>, por tanto no puede hacer más comprobantes de ese mes`
        );
        return;
      }
    },
    cuenta_seleccionada(e, index) {
      let vm = this;
      vm.calcular();
      vm.model.detalles[index].cuenta = "";
      vm.model.detalles[index].cuenta = e.cuenta;
      vm.model.detalles[index].cuenta_id = e.id;
      vm.model.detalles[index].cuentasearch = {};
      this.calcular();
    },
    async getCuentas(cuenta) {
      if (!this.ya_cargo_por_primera_vez) this.cargando = true;
      // eslint-disable-next-line no-undef
      const { data } = await axios.post("/api/catalogos/busquedacta", {
        empresa_id: this.empresaId,
        cuenta,
        tipo: "Operativa",
      });
      if (data && data.data) {
        let cuentas = data.data;
        let suggestions = cuentas;
        this.cuentas = suggestions;
      }
    },
    addrow() {
      this.model.detalles.push({
        cuenta: "",
        empresa: this.empresaId,
        debito: 0,
        credito: 0,
        debito_dol: 0,
        credito_dol: 0,
        tasa_cambio: this.tasa_cambio,
        moneda_id: undefined,
      });
      this.setMoneda();
      this.setCentros();
      this.calcular();
    },
    removerow(index) {
      this.model.detalles.splice(index, 1);
      this.calcular();
    },
    calcular() {
      if (this.model.centro_id === 0) return (this.no_guardar = true);
      let result = 0;
      this.diferencia = 0;
      if (
        this.$route.name == "actualizar_comprobante" ||
        (this.$route.name == "elaborar_cheque" && this.model.tasa_cambio)
      ) {
        this.tasa_cambio = this.model.tasa_cambio;
        if (this.isCk)
          this.monto_ck_temp =
            this.model.moneda_id == 1
              ? parseFloat(this.model.monto_ck)
              : parseFloat(this.model.monto_ck_dol);
      }
      if (parseFloat(this.tasa_cambio) > 0) {
        this.model.tasa_cambio = this.tasa_cambio;
      } else result++;
      this.model.total_debe = 0;
      this.model.total_haber = 0;
      this.model.detalles.forEach((detalle) => {
        detalle.tasa_cambio = this.tasa_cambio;
        detalle.empresa = this.empresaId;
        detalle.moneda_id = this.monedaSelect;
        detalle.debito = detalle.debito_temp
          ? this.Redondear(parseFloat(detalle.debito_temp), 2)
          : 0;
        this.model.total_debe += this.Redondear(detalle.debito,2);
        detalle.credito = detalle.credito_temp
          ? this.Redondear(parseFloat(detalle.credito_temp), 2)
          : 0;
        this.model.total_haber += this.Redondear(detalle.credito,2);

        if (this.monedaSelect == 1) {
          //Si el comprobante es en cordobas
          detalle.debito_dol = this.Redondear(
            detalle.debito / parseFloat(this.tasa_cambio),
            2
          );
          detalle.credito_dol = this.Redondear(
            detalle.credito / parseFloat(this.tasa_cambio),
            2
          );
        } else {
          //Si el comprobante es en dolares
          detalle.debito_dol = detalle.debito;
          detalle.credito_dol = detalle.credito;
          detalle.debito = this.Redondear(
            detalle.debito_temp * parseFloat(this.tasa_cambio),
            2
          );
          detalle.credito = this.Redondear(
            detalle.credito_temp * parseFloat(this.tasa_cambio),
            2
          );
        }
        if (detalle.cuenta == undefined || detalle.cuenta == "") result++;
      });

      if (parseFloat(this.tasa_cambio) > 0) {
        let monto =
          parseFloat(this.model.total_debe) > parseFloat(this.model.total_haber)
            ? parseFloat(this.model.total_debe)
            : parseFloat(this.model.total_haber);
        if (this.monedaSelect == 2) {
          //Si son dolares
          this.equivalente = this.Redondear(monto * parseFloat(this.tasa_cambio), 2);
          this.model.total_debe = this.Redondear(
            this.model.total_debe * this.tasa_cambio,
            2
          );
          this.model.total_debe_dol = monto;
          this.model.total_haber_dol = monto;
          this.model.total_haber = this.Redondear(
            this.model.total_haber * this.tasa_cambio,
            2
          );
          if (this.isCk) {
            this.model.monto_ck_dol = this.monto_ck_temp;
            this.model.monto_ck = this.Redondear(
              this.monto_ck_temp * parseFloat(this.tasa_cambio),
              2
            );
          }
        } else {
          //Si son cordobas
          this.equivalente = this.Redondear(monto / parseFloat(this.tasa_cambio), 2);
          this.model.total_debe_dol = this.equivalente;
          this.model.total_haber_dol = this.equivalente;
          if (this.isCk) {
            this.model.monto_ck = this.monto_ck_temp;
            this.model.monto_ck_dol = this.Redondear(
              this.monto_ck_temp / parseFloat(this.tasa_cambio),
              2
            );
          }
        }
      } else this.equivalente = 0;

      this.diferencia = this.Redondear(
        parseFloat(this.model.total_debe) - parseFloat(this.model.total_haber),
        2
      );
      if (this.diferencia || result) this.no_guardar = true;
      else this.no_guardar = false;

      if (this.isCk) if (!this.model.paguese_a) this.no_guardar = true;
    },
    cambiarFormatoFecha(date) {
      // eslint-disable-next-line no-undef
      this.model.fecha = moment(date).format("YYYY-MM-DD");
      // eslint-disable-next-line no-undef
      this.getTasaCambio(moment(date).format("YYYY-MM-DD"));
    },
    limpiarCentrosDetalles() {
      this.centroSelect = undefined;
    },
    setCentros() {
      this.model.centro_id = this.centroSelect;
    },

    setMoneda() {
      this.calcular();
      if (this.monedaSelect == 2) {
        this.simbolo = "USD";
        this.simbolo_equivalente = "C$";
      } else {
        this.simbolo = "C$";
        this.simbolo_equivalente = "USD";
      }
      this.model.moneda_id = this.monedaSelect;
      this.model.detalles.forEach((detalle) => {
        detalle.moneda = this.monedaSelect;
      });
    },
    async getTasaCambio(e) {
      let tc = 0;
      this.tasa_cambio = tc;
      this.model.tasa_cambio = tc;
      console.log("la fecha que llega es ", e);
      // eslint-disable-next-line no-undef
      let resp = await axios.post("/api/catalogos/tasa-cambio", { fecha: e });
      let res = resp.data;
      let data = res.data[0] ? res.data[0] : 0;
      tc = data.valor ? data.valor : 0;
      this.tasa_cambio = tc;
      this.model.tasa_cambio = tc;
      console.log("la tc es ", this.tasa_cambio);
      this.calcular();
    },
    notAfterToday(date) {
      return date > today;
    },
  },
  computed: {
    ...mapGetters("authentication", ["empresaId"]),
    textoCkTransferencia() {
      if (this.transferencia) return "Transferencia para";
      return "Paguese cheque a";
    },
  },
  watch: {
    fechaSelect: debounce(function (date) {
      this.cambiarFormatoFecha(date);
    }, 30),
  },
};
</script>

<style scoped>
textarea {
  resize: none;
}

.bordecito {
  border: solid 1px silver;
  border-radius: 6px;
  margin: 1em;
  padding-bottom: 0.4em;
}

.nobordertop {
  border-top: none;
}

.noborderrighttop {
  border-right: none;
  border-top: none;
}

.noborderlefttop {
  border-left: none;
  border-top: none;
}

.postip-everywhere {
  /*width: 350px ; */
  width: max-content;
  height: max-content;
  margin: 1px;
  padding: 2px;
  border-radius: 6px 6px 6px 6px;
  /*cursor: move;*/
}

@media (max-width: 320px) {
  #ventana-flotante {
    position: fixed;
    top: 10%;
    left: 6%;
  }
}

@media (max-width: 361px) {
  #ventana-flotante {
    position: fixed;
    top: 25%;
    left: 15%;
  }
}

@media (max-width: 720px) {
  #ventana-flotante {
    position: fixed;
    top: 25%;
    right: 20%;
  }
}

@media (min-width: 721px) {
  #ventana-flotante {
    position: fixed;
    bottom: 10%;
    right: 5%;
  }
}

#ventana-flotante {
  padding: 5px;
  margin: 0px;
  height: max-content;
  color: #1c1301;
  font-size: 12pt;
  font-family: Arial;
  /*width: 359px ;*/
  width: max-content;

  /*cursor: move;*/
  /* Sombra */
  border-radius: 6px 6px 6px 6px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.1);
  background: whitesmoke;
}
#enlaceventanita {
  cursor: pointer !important;
}
#enlaceventanita:hover {
  cursor: pointer !important;
  color: tomato;
}
.mx-datepicker {
  width: 187px;
}
</style>
